import myaxios from './axios.service'
import axios from 'axios'

function convertObjToFormData(keyname, obj)
{
    var formData = new FormData();

    for (var key in obj) {
        formData.append(key, obj[key]);
    }

    formData.append('operation', keyname)
    formData.append('id', '7123')
    formData.append('token', 'MLKZETLlc2O0vJBdD29wgbPQPM1PS9')
    return formData
}

function objectToGetUrlParameters(keyname, obj)
{
    let endString = "id=7123&token=MLKZETLlc2O0vJBdD29wgbPQPM1PS9&operation=" + keyname + '&'
    for (var key in obj) {
        endString += key + '=' + obj[key] + '&'
    }
    return endString.slice(0, -1)
}

const ApiService = {
    post: async function (keyname, obj) {
        return await myaxios.post('', convertObjToFormData(keyname, obj))
    },

    get: async function (keyname, obj) {
        let params = objectToGetUrlParameters(keyname, obj)
        return await axios.get('https://www.districloud.net/app/service/rest/ws.php?action=api_mobile&' + params)
    },

    getUser: async function() {
        let client_id = localStorage.getItem('client_id')
        let result = null
        if (client_id) {
            client_id = JSON.parse(client_id)
            await myaxios.post('', convertObjToFormData('get_conso', {id_conso: client_id}))
            .then((response) => {
                if (response.data.posts) {
                    result = response.data.posts.post
                }
            })
        }
        return result
    }
}
export default ApiService
